import React, { Component } from "react";
import {Select} from "@chakra-ui/react";

import LocalStorageService from "../../../../services/LocalStorageService";

export default class DropdownInput extends Component 
{
    constructor(props)
    {
        super(props);
        this.state =
        {
            options: []
        }
    }


    componentDidMount()
    {
        var options;
        if (this.props.card.dataList)
        {
            var dataList = new LocalStorageService().getDataList(this.props.card.dataList, this.props.gcid);
            options = dataList.data.data.map((d) => {return {label: d.name, value: d.id}});
        }
        else {
            if (this.props.card.options)
            {
                options = this.props.card.options;
            }
        }
        this.setState({options: options});

    }


    selectChange(e) 
    {
        this.props.onValueChange(e.target.value);
    }



    render() 
    {
        return(                
         <Select
         id={this.props.card.id}
        bg="white"
        // value={this.state.cardValue}
        onChange={e => this.selectChange(e)}
    >
        <option selected disabled hidden>Select A Value</option>
        {this.state.options.map((o) => {
            return <option key={o.value} value={o.value}>{o.label}</option>
        })}
    </Select>
        )
    }
}
